<figure class="highcharts-figure">
    <div id="dashborad-line"></div>
  
  </figure>
  <figure class="highcharts-figure">
    <div id="dashborad-line-source"></div>
  </figure>